import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { useNavigate, useParams } from "react-router-dom";
import { GET, PUT } from "../../utils/apicalls";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  notification,
  Row,
} from "antd";
import { Container } from "react-bootstrap";

import moment from "moment";
import PageHeader from "../../admin/pageHeader/pageheader";

function ViewClient() {
  const [UsersData, setUsersData] = useState<any>();
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    getClientData();
  }, []);

  const getClientData = async () => {
    try {
      let api = API.CLIENT_GET_ONE + id;
      const Data: any = await GET(api, {});
      const formData = {
        ...Data?.data,
        start_date: Data?.data?.start_date
          ? moment(Data.data.start_date)
          : null,
        end_date: Data?.data?.end_date ? moment(Data.data.end_date) : null,
      };
      setUsersData(Data?.data);
      form.setFieldsValue(formData);
    } catch (error) {
      console.log("Error fetching user data:", error);
    }
  };

  const onFinish = async (values: any) => {
    try {
      let obj = {
        name: values.name,
        type: values.type,
        username: values.username,
        password: values.password,
        companyName: values.companyName,
        client_email: values.client_email,
        email_password: values.email_password,
        fb_username: values.fb_username,
        fb_password: values.fb_password,
        insta_username: values.insta_username,
        insta_password: values.insta_password,
        hostinger_username: values.hostinger_username,
        hostinger_password: values.hostinger_password,
        wrok_status: values.wrok_status,
        client_phone: values.client_phone,
        address: values.address,
        pincode: values.pincode,
        domain_username: values.domain_username,
        domain_password: values.domain_password,
        linkedin_username: values.linkedin_username,
        whatsapp_client_phone: values.whatsapp_client_phone,
        linkedin_password: values.linkedin_password,
        url: values.url,
        clientId: values.clientId,
        wrokstatus: values.wrokstatus,
        amount: Number(values.amount),
        start_date: values.start_date
          ? moment(values.start_date).format("YYYY-MM-DD")
          : null,
        end_date: values.end_date
          ? moment(values.end_date).format("YYYY-MM-DD")
          : null,
      };
      let api = API.CLIENT_UPDATE + id;
      const postRequest: any = await PUT(api, obj);

      if (postRequest) {
        notification.success({
          message: "client details updated successfully",
        });
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    }
  };

  return (
    <Container>
      <PageHeader />
      <Card className="user-details-card">
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="name"
                label=" Name"
                rules={[{ required: true, message: "Enter Name" }]}
              >
                <Input placeholder=" Name" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="type"
                label=" type"
                rules={[{ required: true, message: "Enter type" }]}
              >
                <Input placeholder=" type" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="username"
                label="username"
                rules={[{ required: true, message: "Enter username" }]}
              >
                <Input placeholder="username" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="password"
                label="password"
                rules={[{ required: true, message: "Enter password" }]}
              >
                <Input placeholder="password" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="companyName"
                label="companyName"
                rules={[{ required: true, message: "Enter companyName" }]}
              >
                <Input placeholder="companyName" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="client_email"
                label="client_email"
                rules={[
                  {

                    type: "email",
                    message: "Enter valid Email",
                  },
                ]}
              >
                <Input placeholder="client_email" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="email_password" label="email_password">
                <Input.Password placeholder="email_password" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="fb_username" label="fb_username">
                <Input placeholder="fb_username" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="fb_password"
                label="fb_password"

              >
                <Input.Password placeholder="fb_password" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="insta_username" label="insta_username">
                <Input placeholder="insta_username" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="insta_password"
                label="insta_password"

              >
                <Input.Password placeholder="insta_password" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="linkedin_username" label="linkedin_username">
                <Input placeholder="linkedin_username" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="linkedin_password"
                label="linkedin_password"

              >
                <Input.Password placeholder="linkedin_password" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="hostinger_username" label="hostinger_username">
                <Input placeholder="hostinger_username" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="hostinger_password" label="hostinger_password">
                <Input.Password placeholder="hostinger_password" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="start_date"
                label="Start Date"
                rules={[{ required: true, message: "Select start date" }]}
                getValueProps={(i) => ({
                  value: i ? moment(i) : null,
                })}
              >
                <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="end_date"
                label="End Date"

                getValueProps={(i) => ({
                  value: i ? moment(i) : null,
                })}
              >
                <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="address"
                label="address"

              >
                <Input.TextArea placeholder="address" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item name="client_phone" label="client Phone">
                <Input placeholder="client Phone" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="whatsapp_client_phone" label="whatsapp number">
                <Input placeholder="whatsapp number" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="pincode" label="pincode">
                <Input placeholder="pincode" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="domain_username" label="domain_username">
                <Input placeholder="domain_username" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="domain_password" label="domain_password">
                <Input.Password placeholder="domain_password" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="url" label="url">
                <Input placeholder="url" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="wrokstatus" label="wrokstatus">
                <Input placeholder="wrokstatus" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="amount" label="amount">
                <Input placeholder="amount" />
              </Form.Item>
            </Col>
          </Row>

          {/* Buttons */}
          <Row className="mt-4" gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Button
                onClick={() => navigate("/Admin/Dashboard")}
                size="large"
                block
                className="cancel-button"
              >
                Cancel
              </Button>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                block
                className="update-button"
              >
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </Container>
  );
}

// Custom input style
const inputStyle = {
  borderRadius: "4px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  padding: "10px",
  border: "1px solid #d9d9d9",
  transition: "border-color 0.3s",
};

export default ViewClient;
